import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AbstractSecurityStorage, AuthModule, DefaultLocalStorageService } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagesModule } from './pages/pages.module';
import { ThemeModule } from './theme/theme.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { PreloaderService } from './services/preloader.service';
import { CheckAuthService } from './services/check-auth.service';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { AudioRecordingService } from './services/audio-recording.service';
import { VideoRecordingService } from './services/video-recording.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { Select2, Select2Hint, Select2Label } from 'ng-select2-component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AuthModule.forRoot({
      config: environment.openIdConfig
    }),
    AppRoutingModule,
    ThemeModule,
    PagesModule,
    RouterModule,
    CKEditorModule,
    Select2,
    Select2Hint,
    Select2Label,
    NgbModule,
    NgbTooltipModule,
    PickerComponent,
    FormsModule,
  ],
  providers: [
    { provide: AbstractSecurityStorage, useClass: DefaultLocalStorageService },
    PreloaderService,
    CheckAuthService,
    AudioRecordingService,
    VideoRecordingService,

    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    })

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
